export default __webpack_public_path__ + "static/img-app-pension-4c80c0d91e91494a19121e29c2bcea4b.png";